import type { ApiParams } from '@Providers';
import { API } from '@Providers';

interface RemoveOutcomeTempFilePayload {
  animalId: string;
  filename: string;
}

export default async function (payload: RemoveOutcomeTempFilePayload) {
  const { animalId } = payload;

  const params: ApiParams = {
    endpoint: `/api/shelter/cart/remove-outcome-temp-file/${animalId}`,
    method: 'post',
    payload,
  };

  return await API(params);
}
